import { Chip as MuiChip, ChipProps } from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

interface Props extends ChipProps {
  className?: string;
}

const ChipImpl = React.forwardRef<HTMLDivElement, Props>(
  ({ className, variant = 'outlined', ...props }, ref) => {
    return (
      <MuiChip className={className} ref={ref} variant={variant} {...props} />
    );
  }
);

/**
 * Customized MUI Chip component.
 *
 * It inherits all properties of a MUI Chip component.
 */
export const Chip = muiStyled(ChipImpl)(({ theme }) => css``);

export default Chip;
